<template>
  <footer class="site-footer bg-pine-950 dark:bg-grey-50 py-8 lg:py-12 min-h-96 text-gold-100 dark:text-grey-950">
    <div class="container">
      <div class="grid lg:grid-cols-2 gap-10 justify-center">
        <div
          class="grid sm:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-x-20 lg:gap-y-12 lg:gap-x-4 lg:flex lg:justify-between xl:grid xl:gap-x-16 lg:col-span-2 order-2 lg:order-1"
        >
          <div>
            <div class="font-display text-2xl font-medium leading-tight mb-4">
              <NuxtLink to="/cms/asiakaspalvelu">Ota yhteyttä</NuxtLink>
            </div>
            <div class="font-semibold mb-3">
              Asiakaspalvelu
            </div>
            <div class="grid gap-2">
              <div class="flex gap-2 items-center">
                <PhoneIcon class="size-5" />
                <a href="tel:0407167228">040 716 7228</a>
              </div>
              <div class="flex gap-2 items-center">
                <EnvelopeIcon class="size-5" />
                <a href="mailto:asiakaspalvelu@tarvike.com">asiakaspalvelu@tarvike.com</a>
              </div>
            </div>
            <div class="font-semibold mt-4 mb-3">
              Myynti
            </div>
            <div class="grid gap-2">
              <div class="flex gap-2 items-center">
                <PhoneIcon class="size-5" />
                <a href="tel:0207437000">020 743 7000</a>
              </div>
            </div>
            <div class="mt-8">
              <BaseButton to="/tilaa-uutiskirje" look="blank" class="items-center rounded-none px-4 py-2 font-semibold border border-gold-100 hover:bg-gold-100 hover:text-pine-950">
                Tilaa uutiskirje
              </BaseButton>
            </div>
          </div>

          <div>
            <div class="font-display text-2xl font-medium leading-tight mb-4">
              <NuxtLink to="/cms/myymalat">Myymälät</NuxtLink>
            </div>
            <ul class="grid gap-2">
              <li>
                <NuxtLink to="/cms/myymalat/oulu">Oulu</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/myymalat/rovaniemi">Rovaniemi</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/myymalat/ranua">Ranua</NuxtLink>
              </li>
            </ul>
          </div>
          <div>
            <div class="font-display text-2xl font-medium leading-tight mb-4">
              <NuxtLink to="/cms/asiakaspalvelu">Asiakaspalvelu</NuxtLink>
            </div>
            <ul class="grid gap-2">
              <li>
                <NuxtLink to="/cms/asiakaspalvelu/ukk">Usein kysytyt kysymykset</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/asiakaspalvelu/toimitusehdot">Tilaus- ja toimitusehdot</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/asiakaspalvelu/toimitustavat-ja-kulut">Toimitustavat ja -kulut</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/asiakaspalvelu/maksutavat">Maksutavat</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/asiakaspalvelu/palautus-reklamaatio-ja-takuu">Palautus, reklamaatio ja takuu</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/asiakaspalvelu/tietosuoja">Tietosuojaseloste</NuxtLink>
              </li>
            </ul>
          </div>
          <div>
            <div class="font-display text-2xl font-medium leading-tight mb-4">
              <NuxtLink to="/cms/palvelut">Palvelumme</NuxtLink>
            </div>
            <ul class="grid gap-2">
              <li>
                <NuxtLink to="/cms/palvelut/rahoitus">Rahoitus</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/palvelut/huoltopalvelut">Huoltopalvelut</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/palvelut/varaosat">Varaosapalvelut</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/palvelut/yrityspalvelut-ja-leasing">Yrityspalvelut ja Leasing</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/cms/palvelut/yksityisleasing">Yksityisleasing</NuxtLink>
              </li>
            </ul>
          </div>
        </div>
        <div class="order-1 lg:order-2 flex justify-center">
          <div class="inline-block bg-white p-4">
            <NuxtLink to="/cms/asiakaspalvelu/maksutavat">
              <img
                src="~/assets/images/footer_payments.jpg"
                loading="lazy"
                alt="Maksutavat Tarvike.comissa"
                title="Maksutavat Tarvike.comissa"
                width="440"
                style="aspect-ratio: 440/101; max-width:min(440px, 100%)"
              >
            </NuxtLink>
          </div>
        </div>
        <div class="pt-6 pb-16 lg:py-0 text-center order-3 flex items-center justify-center lg:col-start-2">
          <div>
            <SiteFooterSocialMediaLinks class="flex gap-8 text-[32px] md:text-[48px]" />
          </div>
        </div>
      </div>
      <div v-if="false" class="bg-surface-raised text-default rounded p-3 mt-8 flex justify-between gap-6">
        <DarkModeToggle />
        <LangSelector />
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { PhoneIcon, EnvelopeIcon } from '@heroicons/vue/24/solid'
</script>

<style lang="scss">
.site-footer {
  a,
  a:link,
  a:visited {
    @apply text-gold-100 hover:text-gold-300 no-underline;
  }
}
.derp-site-footer {
  .footer-heading {
    @apply text-base mb-4 uppercase font-semibold tracking-wider;

    a,
    a:link,
    a:visited {
      @apply text-white;
    }
  }

  ul {
    @apply list-none m-0;

    p {
      @apply p-0 m-0;
    }
  }

  p:empty {
    @apply p-0 m-0;
  }

  a,
  a:link,
  a:visited {
    @apply text-gold-100 hover:text-gold-50 no-underline;
  }
}
</style>
